import { generatePath } from 'react-router-dom';

import PATHS from 'router/PATHS';

export type ActionLibraryInstanceDetailLocationState = {
  backTo?: typeof PATHS.ACTION_INSTANCES_DASHBOARD;
};

type ResolvedActionInstanceDetailBackPath = typeof PATHS.ACTION_INSTANCES_DASHBOARD | typeof PATHS.ACTION_LIBRARY_INSTANCE;

/** Only in-app paths we allow as `backTo` from `location.state` (never trust arbitrary strings). */
export const resolveActionLibraryInstanceDetailBackTarget = (locationState: unknown): ResolvedActionInstanceDetailBackPath => {
  if (locationState == null || typeof locationState !== 'object') {
    return PATHS.ACTION_LIBRARY_INSTANCE;
  }
  const { backTo } = locationState as ActionLibraryInstanceDetailLocationState;
  if (backTo === PATHS.ACTION_INSTANCES_DASHBOARD) {
    return PATHS.ACTION_INSTANCES_DASHBOARD;
  }
  return PATHS.ACTION_LIBRARY_INSTANCE;
};

export const getActionLibraryInstanceDetailLinkFromDashboard = (instanceId: number) => {
  const state: ActionLibraryInstanceDetailLocationState = { backTo: PATHS.ACTION_INSTANCES_DASHBOARD };
  return {
    pathname: generatePath(PATHS.ACTION_LIBRARY_INSTANCE_DETAIL, { id: String(instanceId) }),
    state,
  };
};
